import { Injectable } from "@angular/core";
import * as TokenizerService from "@proto/tokenizer/tokenizer";
import { AuthorizationInterceptor } from "src/app/interceptors/interceptor";
import { endpointBaseGRPC } from "src/main";


@Injectable({
  providedIn: "root",
})
export class GrpcTokenizerService {

  sessionId: string;
  tenantId: string = "8b4a1ab4-cff8-405c-9b7d-13e6cc2a69ba";

  /** Cache em memória por sessão do browser (enquanto o SPA estiver carregado). */
  private supportedBrandsCache: TokenizerService.tokenizer.v1.Brand[] | null = null;
  private supportedBrandsRequest: Promise<TokenizerService.tokenizer.v1.Brand[]> | null = null;

  constructor() {}
  private clientAuth = new TokenizerService.tokenizer.v1.CardTokenizerServiceClient(
    endpointBaseGRPC + "/tokenizer",
    undefined,
    {
      unaryInterceptors: [new AuthorizationInterceptor()],
    },
  );

  generatePublicCertificate(userId: string): Promise<TokenizerService.tokenizer.v1.GeneratePublicCertificateResponse> {
    const request = new TokenizerService.tokenizer.v1.GeneratePublicCertificateRequest({
      userId,
    });
    return this.clientAuth.GeneratePublicCertificate(request, {});
  }

  getInstallments(
    amount: number,
    planId: string,
    brand: TokenizerService.tokenizer.v1.Brand,
    kind: TokenizerService.tokenizer.v1.Kind,
  ): Promise<TokenizerService.tokenizer.v1.GetInstallmentsResponse> {
    const request = new TokenizerService.tokenizer.v1.GetInstallmentsRequest({
      amount,
      productId: planId,
      brand,
      kind,
    });
    return this.clientAuth.GetInstallments(request, {});
  }

  tokenizeCard(encryptedBase64: string, userId: string): Promise<TokenizerService.tokenizer.v1.TokenizeCardResponse> {
    const request = new TokenizerService.tokenizer.v1.TokenizeCardRequest({
      userId,
      encryptedBase64,
    });
    // `encryptedBase64` carrega dados do cartão — só o tamanho é registrado.
    return this.clientAuth.TokenizeCard(request, {});
  }

  getWallet(userId: string): Promise<TokenizerService.tokenizer.v1.GetWalletResponse> {
    const request = new TokenizerService.tokenizer.v1.GetWalletRequest({
      userId,
    });
    return this.clientAuth.GetWallet(request, {});
  }

  deleteCard(cardId: string): Promise<TokenizerService.tokenizer.v1.DeleteCardResponse> {
    const request = new TokenizerService.tokenizer.v1.DeleteCardRequest({
      id: cardId,
    });
    return this.clientAuth.DeleteCard(request, {});
  }

  /**
   * Retorna as bandeiras aceitas para tokenização.
   * Resultado é cacheado em memória por sessão para evitar chamadas repetidas.
   */
  getSupportedBrands(): Promise<TokenizerService.tokenizer.v1.Brand[]> {
    if (this.supportedBrandsCache) {
      return Promise.resolve(this.supportedBrandsCache);
    }

    if (this.supportedBrandsRequest) {
      return this.supportedBrandsRequest;
    }

    const request = new TokenizerService.tokenizer.v1.GetSupportedBrandsRequest({});
    this.supportedBrandsRequest = this.clientAuth
      .GetSupportedBrands(request, {})
      .then((response) => {
        const brands = response.toObject().brands ?? [];
        this.supportedBrandsCache = brands;
        return brands;
      })
      .finally(() => {
        this.supportedBrandsRequest = null;
      });

    return this.supportedBrandsRequest;
  }
}
